export const apiBaseUrl = process.env.NODE_ENV === 'development'
  ? '/api'
  : process.env.VUE_APP_BACKEND_PROTOCOL + '://' + process.env.VUE_APP_BACKEND_HOST;

export function getGraphqlWebSocketUrl () {
  return process.env.NODE_ENV === 'development'
    ? 'wss://' + window.location.host + '/api/graphql'
    : process.env.VUE_APP_BACKEND_WS_PROTOCOL + '://' + process.env.VUE_APP_BACKEND_HOST + '/graphql';
}
export const browserHeaders = { 'Content-Type': 'application/json', 'X-StateMC-Client': 'website' };

export function createSessionClient (baseUrl, fetchImpl = (...args) => fetch(...args)) {
  let pending;

  async function request (method) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetchImpl(baseUrl + '/auth/session', {
        method,
        credentials: 'include',
        headers: browserHeaders,
        cache: 'no-store',
        signal: controller.signal,
      });
      if (method === 'POST' && response.status === 401) return null;
      if (!response.ok) throw new Error('SESSION_UNAVAILABLE');
      return await response.json();
    } catch {
      // HTTP failures, timeouts and browser network errors share a translated UI error code.
      throw new Error('SESSION_UNAVAILABLE');
    } finally {
      clearTimeout(timeout);
    }
  }

  return {
    current () {
      if (!pending) pending = request('POST').finally(() => { pending = undefined; });
      return pending;
    },
    async fresh () {
      if (pending) await pending.catch(() => {});
      return this.current();
    },
    async logout () {
      // Finish our own renewal before deleting cookies.
      if (pending) await pending.catch(() => {});
      return request('DELETE');
    },
  };
}

export const sessionClient = createSessionClient(apiBaseUrl);
